import script from "./SelectorEstructuraArbol.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectorEstructuraArbol.vue?vue&type=script&lang=ts&setup=true"

import "./SelectorEstructuraArbol.vue?vue&type=style&index=0&id=87ff60e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87ff60e4"]])

export default __exports__